import TemplateFolderIcon from 'components/Icons/templateFolderIcon';
import { useSearchQuery } from 'components/AllDialogs/documents/documentsSearch/hooks/useSearchQuery';
import EmptyState from 'components/AllDialogs/documents/documentsSearch/EmptyFilter';
import { ListItem, SearchListCnt } from './style';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box } from '@mui/material';
import AttachmentIcon from 'pages/announcements-page/Builder/AttachmentIcon/attachmentsIcon';
import CheckIcon from '@mui/icons-material/Check';

function SelectableFilesAndFoldersList(props) {
  const { data, setSelectedFolder, selectedFiles, setSelectedFiles } = props;
  const { searchQuery } = useSearchQuery('');

  const { folders, documents: files } = data || {};

  const handleClickFolderLink = (folder) => {
    setSelectedFolder(folder);
  };

  const handleDocumentClick = (file) => {
    setSelectedFiles((prevSelectedFiles) => {
      // Check if file is already selected
      const isSelected = prevSelectedFiles.some(
        (selectedFile) => selectedFile.id === file.id,
      );

      if (isSelected) {
        // If selected, remove it from the array
        return prevSelectedFiles.filter(
          (selectedFile) => selectedFile.id !== file.id,
        );
      } else {
        // If not selected, add the entire file object to the array
        return [...prevSelectedFiles, file];
      }
    });
  };

  const isFileSelected = (fileId) => {
    return selectedFiles.some((file) => file.id === fileId);
  };

  if (data?.length == 0 && searchQuery.isFetched) {
    return <EmptyState />;
  }
  return (
    <>
      <SearchListCnt>
        {folders?.map((item) => {
          return (
            <ListItem key={item.id} onClick={() => handleClickFolderLink(item)}>
              <TemplateFolderIcon
                primaryColor={item?.meta?.primaryColor}
                secondaryColor={item?.meta?.secondaryColor}
              />
              <div className={'textCnt'}>
                <span className={'title'}>{item.title}</span>
              </div>
              <Box ml={'auto'}>
                {/* <span className="selectedItems">3 docs selected</span> */}
                <KeyboardArrowRightIcon
                  style={{ fontSize: 24, color: '#757575' }}
                />
              </Box>
            </ListItem>
          );
        })}
        {files?.map((item) => {
          const isSelected = isFileSelected(item.id);
          return (
            <ListItem
              key={item.id}
              selected={isSelected}
              onClick={() => handleDocumentClick(item)}
            >
              <AttachmentIcon
                fileType={item?.meta?.headInfo?.['content-type']}
              />
              <div className={'textCnt'}>
                <span className={'title'}>{item.title}</span>
              </div>
              {isSelected && (
                <Box ml={'auto'}>
                  <span className="selectedIndicator">
                    <CheckIcon
                      sx={{
                        fontSize: 18,
                        color: '#6868FE',
                      }}
                    />
                  </span>
                </Box>
              )}
            </ListItem>
          );
        })}
      </SearchListCnt>
    </>
  );
}

export default SelectableFilesAndFoldersList;
